import { AxiosResponse } from 'axios'
import { api } from '@services/api'
import { SessionCreate, Session } from './types'
export * from './types'

export const create = async (
  session: SessionCreate
): Promise<AxiosResponse<Session>> => {
  return api.post('/sign_in', { user: session })
}

export const SessionsApi = {
  create
}
